module.exports = __webpack_public_path__ + "img/lot_woodward_cars.9f125280.jpg";